import { useParameterCategories } from 'queryHooks/TrackmanParameters/useParameterCategories';
import { useTrackmanParametersSelectionStore } from 'stores/TrackmanParameters/trackmanParametersSelectionStore';
import { ParameterCategoryView, ParameterModel, ParameterSubcategoryView } from 'types/trackmanParameters';

export const useTrackmanParametersNavigation = () => {
  const { data: categories = [], isLoading, isError } = useParameterCategories();
  const { selectedCategoryId, selectedSubcategoryId, selectedParameterId, selectCategory, selectSubcategory, selectParameter } =
    useTrackmanParametersSelectionStore();

  const selectedCategory: ParameterCategoryView | undefined =
    categories.find((c) => c.id === selectedCategoryId) ?? categories[0];
  const selectedSubcategory: ParameterSubcategoryView | undefined =
    selectedCategory?.subcategories.find((s) => s.id === selectedSubcategoryId) ?? selectedCategory?.subcategories[0];
  const parametersInSelectedSubcategory: ParameterModel[] = selectedSubcategory?.parameters ?? [];
  const selectedParameter: ParameterModel | undefined =
    parametersInSelectedSubcategory.find((p) => p.id === selectedParameterId) ?? parametersInSelectedSubcategory[0];

  return {
    isLoading,
    isError,

    categories,
    selectedCategory,
    selectCategory,

    subcategories: selectedCategory?.subcategories ?? [],
    selectedSubcategory,
    selectSubcategory,

    parametersInSelectedSubcategory,
    selectedParameter,
    selectParameter,
  };
};
